import { setupLayouts } from "virtual:meta-layouts"
import { createRouter, createWebHistory } from "vue-router/auto"
import { setupGuards } from "./guards"

function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])

    return route
  }

  return setupLayouts([route])[0]
}

// Dinamik olarak views klasörü altındaki tüm router.js ve route.js dosyalarını bul
const routerModules = import.meta.glob('../../views/**/{router,route}.js', { eager: true })

const additionalRoutes = []

Object.keys(routerModules).forEach(path => {
  const mod = routerModules[path]

  // Modül içindeki export edilen değerleri (dizi olanları) alıyoruz
  Object.values(mod).forEach(exportedValue => {
    if (Array.isArray(exportedValue)) {
      additionalRoutes.push(...exportedValue)
    }
  })
})

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 60 }

    return { top: 0 }
  },
  extendRoutes: pages => [
    ...[
      ...pages,
      ...additionalRoutes,
    ].map(route => recursiveLayouts(route)),
  ],
})

setupGuards(router)
export { router }
export default function (app) {
  app.use(router)
}
